import { InactiveCollectionMarkerProps } from '../../types/components/shared/InactiveCollectionMarker';

const InactiveCollectionMarker: React.FC<InactiveCollectionMarkerProps> = ({
  collection,
}) => {
  if (collection.active) return;

  return (
    <div cy-test-id="inactive-collection-marker" className="text-gray-500 max-md:px-6 py-4">
      This product is no longer available.
    </div>
  )
}

export default InactiveCollectionMarker;
